var _path, _path2, _path3, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCdtteamShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.493,
    height: 98.66,
    viewBox: "0 0 99.493 98.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.2,801.174a49.748,49.748,0,1,1-49.746-49.329A49.538,49.538,0,0,1,421.2,801.174Z",
    transform: "translate(-321.704 -751.845)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406.962,768.681a48.7,48.7,0,0,0-34.3-14.074h0a48.706,48.706,0,0,0-34.3,14.073,47.518,47.518,0,0,0-14.249,33.884h0a47.52,47.52,0,0,0,14.249,33.884,48.7,48.7,0,0,0,34.3,14.074h0a48.7,48.7,0,0,0,34.3-14.073,47.519,47.519,0,0,0,14.25-33.886h0A47.51,47.51,0,0,0,406.962,768.681Zm12.82,33.884h0a46.115,46.115,0,0,1-13.825,32.883A47.274,47.274,0,0,1,372.664,849.1h0a47.268,47.268,0,0,1-33.293-13.659,46.1,46.1,0,0,1-13.827-32.881h0a46.111,46.111,0,0,1,13.827-32.882,47.269,47.269,0,0,1,33.293-13.658h0a47.269,47.269,0,0,1,33.294,13.659,46.111,46.111,0,0,1,13.825,32.881Z",
    transform: "translate(-322.916 -753.235)",
    fill: "#1e3d8e",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.6,783.35a33.679,33.679,0,1,0,33.8,33.678A33.8,33.8,0,0,0,387.6,783.35Z",
    transform: "translate(-337.857 -767.699)",
    fill: "#1e3d8e",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.585 21.319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.875,885.019l1.324,4.038h4.281l-3.463,2.495,1.322,4.038-3.464-2.5-3.463,2.5,1.324-4.038h0l-3.462-2.495h4.281Z",
    transform: "translate(-392.864 -840.178)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.592,828.481l1.322,4.037H460.2l-3.465,2.5,1.323,4.038-3.463-2.5-3.464,2.5,1.323-4.038h0l-3.463-2.5h4.281Z",
    transform: "translate(-411.339 -811.727)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.777,844.684l.983,3h3.188l-2.577,1.857.985,3.006-2.578-1.857-2.577,1.857.984-3.006h0l-2.576-1.857h3.186Z",
    transform: "translate(-399.07 -819.881)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.192,794.758l1.324,4.037H421.8l-3.463,2.5,1.322,4.037-3.464-2.494-3.463,2.494,1.323-4.037h0l-3.464-2.5h4.281Z",
    transform: "translate(-392.016 -794.758)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.809,827.8l1.323,4.038h4.282l-3.464,2.5,1.324,4.036-3.465-2.494-3.464,2.494,1.324-4.036h0l-3.464-2.5h4.282Z",
    transform: "translate(-373.204 -811.385)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.471 4.417)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.025 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.622,799.108a1.509,1.509,0,0,0-1.983.481c-.752,1.112.1,2.192,1.14,2.888s2.375,1.063,3.127-.048c.541-.8.186-1.487-.447-2.114l1.579-2.331a3.969,3.969,0,0,1,.851,5.671,4.577,4.577,0,0,1-6.717,1.2c-2.45-1.63-3.032-4.243-1.425-6.617a3.849,3.849,0,0,1,5.443-1.434Z",
    transform: "translate(-344.844 -778.589)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.891,781.715l4.28-3.414c1.275-1.018,2.945-1.2,4.055.167a2.365,2.365,0,0,1,.378,2.685,2.561,2.561,0,0,1,2.536.947,6.117,6.117,0,0,0,1.5,1.354l-2.247,1.792a6.854,6.854,0,0,1-1.088-.967c-.62-.64-1.264-1.31-2.152-.6l-1.2.954,2.047,2.521-2.247,1.793Zm4.81,1.368,1.174-.937c.419-.335.933-.861.408-1.509-.37-.457-.839-.516-1.7.169l-1.052.838Z",
    transform: "translate(-351.913 -769.166)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.217,769.361c.943,2.4.09,4.053-2.573,5.083s-4.434.39-5.377-2.008l-2.087-5.3,2.686-1.038,1.854,4.711c.347.883.782,1.987,2.088,1.48,1.271-.492.837-1.593.49-2.478l-1.855-4.711,2.688-1.04Z",
    transform: "translate(-363.129 -762.407)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.639,768.35l4-4.969-4.094.3-.173-2.373,7.885-.57.153,2.074-4.027,5.127,4.589-.332.174,2.372-8.342.6Z",
    transform: "translate(-376.307 -760.735)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.343,761.464l7.573,1.633-.511,2.325-4.752-1.025-.248,1.132,4.318.93-.473,2.16-4.318-.93-.248,1.131,4.9,1.055-.511,2.325-7.712-1.663Z",
    transform: "translate(-387.371 -761.102)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.314,768.255l2.612,1.213-3.97,8.408-2.612-1.213Z",
    transform: "translate(-397.429 -764.519)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.124,775.119l4.32,3.362c1.29,1,1.845,2.575.752,3.956a2.413,2.413,0,0,1-2.552.971,2.51,2.51,0,0,1-.358,2.662,6.068,6.068,0,0,0-.99,1.758l-2.269-1.767a6.661,6.661,0,0,1,.7-1.269c.489-.744,1-1.517.1-2.216l-1.207-.938-2.016,2.547-2.268-1.767Zm-.256,4.955,1.185.922c.424.329,1.056.707,1.574.053.366-.461.318-.927-.549-1.6l-1.062-.826Z",
    transform: "translate(-402.462 -767.973)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.9,798.147a4.544,4.544,0,0,1-1.389,6.624,4.628,4.628,0,0,1-6.721-1.161,4.544,4.544,0,0,1,1.389-6.624A4.629,4.629,0,0,1,487.9,798.147Zm-6.18,4.164c.413.6,1.448,1.256,3.171.094s1.491-2.356,1.079-2.958-1.446-1.256-3.171-.095S481.312,801.709,481.724,802.311Z",
    transform: "translate(-412.306 -778.499)",
    fill: "#1e3d8e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 37.443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.568,844.787l-.582-7.662,2.394-.179.365,4.809,1.163-.086-.332-4.37,2.223-.166.332,4.37,1.162-.087-.376-4.951,2.393-.179.594,7.8Z",
    transform: "translate(-412.365 -836.196)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.435,866.719l1.078-4.97c.517-2.389,1.987-2.608,2.921-2.409a1.921,1.921,0,0,1,1.553,1.5,2.289,2.289,0,0,1,2.623-1.089c1.832.391,2.44,2.169,2.093,3.77l-1.118,5.147Zm4.169-2.037.321-1.474c.125-.585.039-.989-.55-1.113-.462-.1-.71.246-.835.819l-.32,1.474Zm3.41.727.354-1.639c.128-.585.07-1.129-.635-1.279-.539-.115-.9.141-1.046.8l-.38,1.753Z",
    transform: "translate(-411.081 -847.768)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.559,881.507c2.265,1.259,2.665,3.077,1.267,5.55s-3.177,3.094-5.441,1.834l-5.01-2.785,1.41-2.494,4.451,2.472c.834.465,1.875,1.043,2.561-.17.666-1.18-.374-1.758-1.208-2.223l-4.45-2.473,1.41-2.494Z",
    transform: "translate(-406.019 -857.551)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.647,904.705l2.043-2.02,4.913,4.89,2.935-2.9,1.693,1.685-4.977,4.918Z",
    transform: "translate(-399.614 -869.609)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.173,915.168a1.508,1.508,0,0,0-1.986-.469c-1.18.649-.923,1.994-.313,3.085s1.624,2.021,2.8,1.372c.849-.469.852-1.241.574-2.084l2.476-1.362a3.972,3.972,0,0,1-1.85,5.431,4.571,4.571,0,0,1-6.526-1.971,4.478,4.478,0,0,1,1.773-6.532c2.253-1.225,4.146-.734,5.5,1.181Z",
    transform: "translate(-391.547 -874.28)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.488,922.672l7.732-.471.149,2.374-4.856.3.074,1.155,4.409-.27.138,2.206-4.41.27.071,1.154,5-.3.147,2.375-7.877.48Z",
    transform: "translate(-374.877 -879.429)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.058,922.309l-2.561-.558.513-2.323,7.941,1.728-.513,2.324-2.562-.557-1.492,6.743-2.818-.613Z",
    transform: "translate(-364.314 -878.034)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.693,910.146l4.816,2.62c1.437.78,2.245,2.242,1.393,3.782a2.412,2.412,0,0,1-2.359,1.372,2.509,2.509,0,0,1,.084,2.685,6.1,6.1,0,0,0-.689,1.894l-2.528-1.374a6.72,6.72,0,0,1,.485-1.367c.362-.812.739-1.66-.261-2.2l-1.344-.733-1.57,2.839-2.529-1.375Zm.561,4.932,1.323.719c.47.256,1.159.527,1.563-.2.283-.511.16-.965-.8-1.489l-1.185-.643Z",
    transform: "translate(-351.077 -873.363)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.843,899.016a4.541,4.541,0,0,1-.25,6.762,4.632,4.632,0,0,1-6.824-.028,4.543,4.543,0,0,1,.25-6.763A4.634,4.634,0,0,1,361.843,899.016Zm-5.391,5.132c.509.525,1.639,1,3.143-.434s1.074-2.57.566-3.095-1.64-1-3.144.433S355.944,903.622,356.452,904.148Z",
    transform: "translate(-342.113 -867.001)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.687,876.595l2.177,4.268a3.134,3.134,0,0,1-1.3,4.469c-2.023,1.016-3.657.147-4.628-1.756l-.771-1.507-2.526,1.267-1.3-2.551Zm-2.535,4.477.5.985c.337.662.74,1.333,1.583.911.759-.382.51-.984.191-1.611l-.58-1.138Z",
    transform: "translate(-334.041 -856.48)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.23,861.5a1.737,1.737,0,0,0-.584.22,1.311,1.311,0,0,0-.4,1.469c.09.46.383,1.131,1.064,1,.477-.091.527-.512.669-2.169.128-1.521.2-3.245,2.056-3.6,2.124-.411,3.391,1.211,3.761,3.087.389,1.978-.026,3.873-2.25,4.383l-.523-2.654a.716.716,0,0,0,.669-.473,1.48,1.48,0,0,0,.068-.874c-.076-.383-.3-.989-.817-.889-.646.178-.532,1.509-.638,2.866s-.46,2.752-2.146,3.078c-2.394.464-3.6-1.568-4-3.6-.2-1.034-.411-4.053,2.518-4.648Z",
    transform: "translate(-331.383 -847.3)",
    fill: "#1e3d8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.67,836.853l-.625,7.659-2.391-.192.392-4.808-1.164-.093-.355,4.367-2.222-.177.356-4.368-1.163-.092-.4,4.95-2.39-.192.634-7.8Z",
    transform: "translate(-330.703 -836.105)",
    fill: "#1e3d8e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdtteamShield);
export default __webpack_public_path__ + "static/media/cdtteam-shield.140062edfa18ef4f83b2503fdbfe3e96.svg";
export { ForwardRef as ReactComponent };